import React from 'react';
const highlights = [{
  value: '365',
  label: 'Days of sessions'
}, {
  value: '14',
  label: 'Coaching volumes'
}, {
  value: 'All',
  label: 'Age groups'
}, {
  value: '6',
  label: 'Strategic bonuses'
}];
export function ProductHero() {
  return <section className="bg-ink-soft px-5 py-14 md:py-24 text-center" data-id="element-195" data-mp="363560s06gcx">
      <div className="max-w-5xl mx-auto" data-id="element-196" data-mp="348hwft9ec5o">
        <p className="text-[0.7rem] md:text-xs font-bold uppercase tracking-[0.16em] text-acid mb-3" data-id="element-197" data-mp="qvxhmh8eu2wn">
          The complete system
        </p>
        <h2 className="font-display uppercase text-white text-[7vw] min-[430px]:text-3xl md:text-5xl leading-[1.05] mb-4" data-id="element-198" data-mp="uvoen2oj5f9m">
          Rugby 360 — the complete{' '}
          <span className="text-acid" data-id="element-199" data-mp="lw1eek7jefi5">rugby coaching bible.</span>
        </h2>
        <p className="text-gray-300 text-sm md:text-lg max-w-2xl mx-auto mb-10 md:mb-14" data-id="element-200" data-mp="31np6a17p1hu3">
          One system that covers every age group, every block of the season and
          every session you will run this year.
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10" data-id="element-201" data-mp="3cgq8px94id33">
          {highlights.map(item => <div key={item.label} className="bg-ink-soft py-7 md:py-9 px-3" data-id="element-202" data-mp="38g6aeqctd3fd">
              <div className="font-display uppercase text-acid text-3xl md:text-5xl mb-1.5" data-id="element-203" data-mp="3mexl02sgw6yr">
                {item.value}
              </div>
              <div className="text-[0.6rem] md:text-xs uppercase tracking-[0.12em] text-gray-400 font-medium" data-id="element-204" data-mp="3hhe5z0ny3q5r">
                {item.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}